import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { ArrowRight, ArrowLeft, Phone } from 'lucide-react';
import { Button } from './ui/button';
import { businessInfo } from '../mockData';
import { posts } from '../content/blog';
import usePageMeta from '../hooks/usePageMeta';
import NotFound from '../pages/NotFound';

const bySlug = Object.fromEntries(posts.map((p) => [p.slug, p]));

// Tailwind arbitrary variants style the trusted HTML body without a typography plugin.
const proseClasses =
  '[&_h2]:text-2xl [&_h2]:font-bold [&_h2]:text-gray-900 [&_h2]:mt-9 [&_h2]:mb-3 ' +
  '[&_p]:text-gray-700 [&_p]:leading-relaxed [&_p]:mb-4 ' +
  '[&_ul]:list-disc [&_ul]:pl-6 [&_ul]:mb-5 [&_ul]:space-y-1 [&_li]:text-gray-700 ' +
  '[&_a]:text-red-600 [&_a]:font-semibold hover:[&_a]:underline [&_strong]:text-gray-900';

const BlogPost = () => {
  const { slug } = useParams();
  const post = bySlug[slug];
  usePageMeta();
  if (!post) return <NotFound />;

  return (
    <div className="min-h-screen" key={slug}>
      <section className="bg-gray-950 py-14 sm:py-16 text-white">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <Link to="/blog" className="inline-flex items-center gap-1.5 text-gray-400 hover:text-white text-sm mb-6">
            <ArrowLeft size={15} /> All guides
          </Link>
          <p className="text-xs uppercase tracking-wider text-red-400 font-semibold mb-3">{post.date}</p>
          <h1 className="text-3xl sm:text-4xl font-bold leading-tight">{post.title}</h1>
        </div>
      </section>

      <article className="py-12 sm:py-16 bg-white">
        <div className={`max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 ${proseClasses}`} dangerouslySetInnerHTML={{ __html: post.body }} />
      </article>

      <section className="py-14 bg-gray-950">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-bold text-white mb-3">Locked out or need a quote?</h2>
          <p className="text-lg text-gray-300 mb-7">Mobile locksmith across the North Shore — fixed quotes, no surprises.</p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a href={`tel:${businessInfo.phoneTel}`}>
              <Button size="lg" className="bg-red-600 text-white hover:bg-red-700 font-bold">
                <Phone className="mr-2" size={20} />
                Call {businessInfo.phone}
              </Button>
            </a>
            <Link to="/contact">
              <Button size="lg" variant="outline" className="border-white text-white hover:bg-white/10 font-semibold">
                Get a quote <ArrowRight className="ml-2" size={18} />
              </Button>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default BlogPost;
